<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiHome } from "@mdi/js";
export default {
  name: "MdiHome",
  data() {
    return {
      svgPath: mdiHome,
    };
  },
};
</script>
